import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { ClickedNotificationEvent } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { NotificationEventTrackingFieldsFragment } from '@reverbdotcom/commons/src/gql/graphql';

export function clickedNotificationEvent(
  eventTracking: NotificationEventTrackingFieldsFragment,
): ClickedNotificationEvent {
  return {
    eventName: MParticleEventName.ClickedNotification,
    notificationType: eventTracking.notificationType,
    notificationId: eventTracking.notificationId,
    name: eventTracking.name,
    position: eventTracking.position,
    listingId: eventTracking.listingId,
    cpId: eventTracking.cpId,
    discountAmountCents: eventTracking.discountAmountCents,
    discountAmountCurrency: eventTracking.discountAmountCurrency,
    discountPercent: eventTracking.discountPercent,
  };
}
